module.exports = __webpack_public_path__ + "img/ic_32_sport_basketball-white.ae4041fc.svg";